import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=f46ff53a&scoped=true&"
import script from "./MasterData.vue?vue&type=script&lang=js&"
export * from "./MasterData.vue?vue&type=script&lang=js&"
import style0 from "./MasterData.vue?vue&type=style&index=0&id=f46ff53a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46ff53a",
  null
  
)

export default component.exports